export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const REFRESH_CURRENT_USER = "REFRESH_CURRENT_USER";
export const RESET_CURRENT_USER = "RESET_CURRENT_USER";
export const SET_CURRENT_USER_REQUEST_STATUS = "SET_CURRENT_USER_REQUEST_STATUS";

export interface Tier {
  title: string;
}
